import { AppSourceEnum } from 'pu-core-library';
import { RechercheForm } from '@features/mes-financements/features/mes-financements-recherche/models/recherche-form';
import { DossierSearchCriteria } from '@features/mes-financements/features/mes-financements-recherche/models/recherche-request';
import { CategoryFolderEnum } from '@shared/enums/categorie.enum';
import { RechercheColonneEnum } from '@shared/enums/recherche-colonne.enum';
import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { FinancementRechercheExportRequest } from '../models/financement-recherche-export-request';
import { Dispositif } from '@features/referentiel/models/dispositif';

const isNonEmpty = (v?: string | null) => !!v && v.trim() !== '';

function buildCommonCriteria(form: RechercheForm) {
  const out: any = {};

  if (form.solder !== null) out.dossierASolder = form.solder;

  if (isNonEmpty(form.numDossier)) out.numeroDossier = form.numDossier;

  if (isNonEmpty(form.statut)) out.statutDossier = form.statut;
  if (isNonEmpty(form.decision)) out.dateDecisionOperateur = form.decision;

  if (form.dateDecision) out.dateDecision = form.dateDecision.toLocaleDateString();
  if (form.dateDebut) out.dateDebutFormation = form.dateDebut.toLocaleDateString();
  if (form.dateFin) out.dateFinFormation = form.dateFin.toLocaleDateString();

  if (isNonEmpty(form.nomStagiaire)) out.nomStagiaire = form.nomStagiaire;
  if (isNonEmpty(form.prenomStagiaire)) out.prenomStagiaire = form.prenomStagiaire;

  if (form.paiementOrganismeLabel !== '') {
    out.paiementOrganisme = form.paiementOrganisme;
  }

  return out;
}

export class MesFinancementsFunctions {
  static searchFormToDossierSearchCriteria(
    sirets: string[],
    form: RechercheForm,
    categorie: CategoryFolderEnum,
  ): DossierSearchCriteria {

    const common = buildCommonCriteria(form);

    const dossierCriteria: DossierSearchCriteria = {
      sirets: sirets,
      type: AppSourceEnum.POF,
      categorieDossier: categorie,

      page: form.page,
      orderBy: form.orderBy ?? OrderByEnum.DESC,
      orderByColumn: form.orderByColumn ?? RechercheColonneEnum.DATE_CREATION,
      ...common
    };


    if (form.typeDispositif && form.typeDispositif !== "")
      dossierCriteria.dispositif = form.typeDispositif;

    if (form.typeDispositifLibelle && form.typeDispositifLibelle !== "")
      dossierCriteria.dispositifLibelle = form.typeDispositifLibelle;

    return dossierCriteria;

  }

  static searchFormToFinancementRechercheExportRequest(
    sirets: string[],
    form: RechercheForm,
    categorie: CategoryFolderEnum,
    dispositifs: Dispositif[]
  ): FinancementRechercheExportRequest {
    const common = buildCommonCriteria(form);

    const dossierCriteria: FinancementRechercheExportRequest = {
      sirets: sirets,
      categorieDossier: categorie,
      ...common
    };

    if (form?.typeDispositif) {
      const selectedDispositif = dispositifs.find(d => d.id === form.typeDispositif);
      dossierCriteria.codeDispositif = selectedDispositif?.code;
    }

    return dossierCriteria;
  }

  static mapToRechercheColonneEnum(field: string | undefined) {
    if (field === RechercheColonneEnum['DISPOSITIF_NAME']) {
      return RechercheColonneEnum.DISPOSITIF_NAME;
    }
    if (field === RechercheColonneEnum['SIRET']) {
      return RechercheColonneEnum.SIRET;
    }
    if (field === RechercheColonneEnum['STATUT']) {
      return RechercheColonneEnum.STATUT;
    }
    if (field === RechercheColonneEnum['NUMERO_DOSSIER']) {
      return RechercheColonneEnum.NUMERO_DOSSIER;
    }
    if (field === RechercheColonneEnum['LIBELLE_FORMATION']) {
      return RechercheColonneEnum.LIBELLE_FORMATION;
    }
    if (field === 'dateFormation') {
      return RechercheColonneEnum.DATE_DEBUT;
    }
    if (field === RechercheColonneEnum['DATE_DECISION']) {
      return RechercheColonneEnum.DATE_DECISION;
    }
    if (field === RechercheColonneEnum['MONTANT_ENGAGE']) {
      return RechercheColonneEnum.MONTANT_ENGAGE;
    }
    if (field === RechercheColonneEnum['STAGIAIRES']) {
      return RechercheColonneEnum.STAGIAIRES;
    }
    return RechercheColonneEnum.DATE_CREATION;
  }
}
